
import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  ref,
  computed,
  SetupContext,
} from 'vue'
import VideoCategoryCard from '../video-category-card/index.vue'
import PictureCategoryCard from '../picture-category-card/index.vue'
import List from '../list/index.vue'
import { useVideoList } from './useVideoList'

export default defineComponent({
  components: {
    VideoCategoryCard,
    List,
    PictureCategoryCard,
  },
  props: {
    muted: {
      type: Boolean,
      default: true,
    },
    isLoginStatus: {
      type: Boolean,
      default: false,
    },
    videoIndex: {
      type: Number,
      default: 0,
    },
    firstCardFinishLoad: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, ctx: SetupContext<Array<'onFirstFinishRender'>>) {
    const { proxy } = getCurrentInstance() as { proxy: any }
    const videoCategoryCardRefs = ref([] as any)

    const { finished, loading, loadMorePost } = useVideoList()

    const feeds = computed(() => {
      let feedsList: any = []
      proxy.$store.state.newDiscoverModule.videoCategoryCardList.forEach(
        (item: any) => {
          if (
            !videoCategoryCardPidList.value.includes(item.photo_id_str) &&
            !videoCategoryCardPidList.value.includes(item.pic_id_str)
          ) {
            feedsList.push(item)
          }
        }
      )
      return feedsList
    })

    const videoCategoryCardPidList = computed(() => {
      return proxy.$store.state.newDiscoverModule.videoCategoryCardPidList
    })

    const handleFirstFinishRender = (index: number) => {
      ctx.emit('onFirstFinishRender', index);
    }

    onMounted(() => {
      loadMorePost()
    })

    return {
      finished,
      loading,
      feeds,
      loadMorePost,
      videoCategoryCardPidList,
      videoCategoryCardRefs,
      handleFirstFinishRender,
    }
  },
})
